"use client";

import { MotionConfig } from "framer-motion";
import type { ReactNode } from "react";

/**
 * Single place that decides how framer-motion animates across the app.
 * `reducedMotion="user"` drops transform/layout animations (keeps opacity) when the OS asks for it.
 * Switching this to "always" is the global kill switch for all framer-driven motion.
 */
export const MotionProvider = ({ children }: { children: ReactNode }) => (
    <MotionConfig reducedMotion="user">{children}</MotionConfig>
);
